import ImageWithFallback from '@/components/common/image-with-fallback'
import Link from 'next/link'

function Community({ community }) {
  return (
    <Link
      href={`/c/${community.slug}`}
      passHref={true}
      className="flex gap-4 rounded bg-neutral-blue-700 p-4 desktop-sm:p-0"
    >
      <div className="relative aspect-square h-24 items-center overflow-hidden rounded bg-neutral-blue-900">
        <ImageWithFallback
          src={community.logoImgUrl ? community.logoImgUrl : undefined}
          alt="Community Logo Image"
          fill
        />
      </div>

      <div className="flex flex-col">
        <div className="flex flex-col">
          <p className="text-shades-0">{community.name}</p>
        </div>
      </div>
    </Link>
  )
}

export default function CommunitiesSection({ session, user, communities }) {
  const uniqueCommunitiesById = communities
    ? [...new Map(communities.map((item) => [item.id, item])).values()].sort(
        (a, b) => (b._count?.members || 0) - (a._count?.members || 0),
      )
    : []

  return (
    <div className="flex w-full flex-col gap-4 rounded bg-neutral-blue-700 p-8 xl:gap-10">
      <p className="text-center font-syncopate text-xl font-bold uppercase text-shades-0 xl:text-start xl:text-2xl">
        Communities
      </p>
      {uniqueCommunitiesById.length > 0 ? (
        <div className="grid auto-cols-fr grid-flow-row auto-rows-fr gap-2 desktop-sm:grid-cols-2 desktop-sm:gap-8">
          {uniqueCommunitiesById.map((com, comIndex) => (
            <Community key={`Community${comIndex}`} community={com} />
          ))}
        </div>
      ) : (
        <div className="grid flex-1 text-center">
          <p className="flex h-36 items-center justify-center text-center text-xl text-shades-0">
            {session && session.user.id === user.id
              ? 'You have not joined any communities yet.'
              : 'This user has not joined any communities yet.'}
          </p>
        </div>
      )}
    </div>
  )
}
